import MojitoCore from 'mojito/core';
import BetHistoryImpl from './bet-history-controller-view.js';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';
const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * A module for viewing bet history.
 *
 * @class BetHistory
 * @name module
 * @memberof Mojito.Modules.BetHistory
 */

/**
 * BetHistory prop types.
 *
 * @property {Function} [onBetClick = ()=>{}] - Callback on bet item click.
 * @memberof Mojito.Modules.BetHistory.module
 */
const propTypes = {
    onBetClick: PropTypes.func,
};

const defaultProps = {
    onBetClick: noop,
};

export default UIControllerView('BetHistory', BetHistoryImpl, propTypes, defaultProps);
